import HotSpotDisplay from './HotSpotDisplay';

export default HotSpotDisplay;
